export default __webpack_public_path__ + "static/media/06.cd4dbc7d.png";